import { Colors } from '@/common/colors/colors';
import {
	ANNEX_TYPES_OPTIONS,
	PERSONAL_DOCUMENTS_OPTIONS,
} from '@/common/constants/personalDocuments';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import moment from 'moment';
import { useMemo, useRef, useState } from 'react';
import ActionButton from '../buttons/ActionButton';
import Input from '../Input';
import PopUp from '../PopUp';
import SelectInput from '../SelectInput';
import { ButtonWrapper } from './AddPersonalDocument.styled';

const AddPersonalDocument = ({ setShow, submitFn, edit }) => {
	const [selectedDoc, setSelectedDoc] = useState();
	const [selectedAnnexType, setSelectedAnnexType] = useState();
	const fromRef = useRef();
	const toRef = useRef();

	const { addMessage } = useMessageQueueContext();

	const handleSave = () => {
		if (!edit) {
			const fromValue = fromRef.current?.value;
			const annexWithoutType =
				selectedDoc?.value === 'annex' && !selectedAnnexType;
			const notPermWithoutTo =
				selectedDoc?.value !== 'permanent' && !toRef.current?.value;

			const isFormInvalid =
				!selectedDoc || annexWithoutType || !fromValue || notPermWithoutTo;

			if (isFormInvalid) {
				return addMessage('Fill all fields');
			}
		} else {
			if (!toRef.current?.value) {
				return addMessage("Add new 'to date'");
			}
		}

		const payload = [
			{
				name: selectedDoc?.value,
				from: moment(fromRef.current?.value).format('YYYY-MM-DD'),
				to:
					toRef.current?.value &&
					moment(toRef.current.value).format('YYYY-MM-DD'),
				annex_type:
					selectedDoc.value === 'annex' ? selectedAnnexType.value : undefined,
			},
		];

		submitFn?.(payload);
		setShow(false);
	};

	const isAnnexTypeVisible = useMemo(
		() => selectedDoc?.value === 'annex',
		[selectedDoc],
	);

	return (
		<PopUp padding='10px 20px 10px' setShow={setShow}>
			{!edit && (
				<>
					<SelectInput
						options={PERSONAL_DOCUMENTS_OPTIONS}
						color={Colors.darkBlue}
						setSelected={setSelectedDoc}
						name='Document'
						width={110}
					/>
					{isAnnexTypeVisible && (
						<SelectInput
							options={ANNEX_TYPES_OPTIONS}
							color={Colors.darkBlue}
							setSelected={setSelectedAnnexType}
							name='Annex type'
							width={110}
						/>
					)}
					<Input
						inputRef={fromRef}
						name='From'
						type='date'
						color={Colors.darkBlue}
						width={110}
					/>
				</>
			)}
			{selectedDoc?.value !== 'permanent' && (
				<Input
					inputRef={toRef}
					name='To'
					type='date'
					color={Colors.darkBlue}
					width={110}
				/>
			)}
			<ButtonWrapper>
				<ActionButton onClick={handleSave} defaultText='Save' />
			</ButtonWrapper>
		</PopUp>
	);
};

export default AddPersonalDocument;
